import { render, staticRenderFns } from "./PostRow.vue?vue&type=template&id=65f1b892&scoped=true"
import script from "./PostRow.vue?vue&type=script&lang=js"
export * from "./PostRow.vue?vue&type=script&lang=js"
import style0 from "./PostRow.vue?vue&type=style&index=0&id=65f1b892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1b892",
  null
  
)

export default component.exports